import { Link } from "react-router-dom";
import { getChamamentoCopy, getChamamentoStatus } from "@/lib/competitionApplication";

/**
 * Chamada da Home para o Chamamento 2027. Some sozinha depois do encerramento
 * (o rodapé e a própria página ficam como arquivo).
 */
export default function ChamamentoSection() {
  const status = getChamamentoStatus();
  if (status.window === "closed") return null;
  const { deadline, cta } = getChamamentoCopy(status);

  return (
    <section aria-labelledby="chamamento-home-titulo" className="border-y border-border bg-secondary/30 py-10 md:py-14">
      <div className="container mx-auto px-4">
        <div className="mx-auto flex max-w-5xl flex-col gap-6 md:flex-row md:items-center md:justify-between md:gap-10">
          <div className="min-w-0">
            <h2 id="chamamento-home-titulo" className="font-display text-3xl uppercase leading-tight md:text-4xl">
              Sua competição pode ser etapa oficial em 2027
            </h2>
            <p className="mt-3 max-w-2xl leading-relaxed text-muted-foreground">
              Até 5 competições entram no calendário do Ranking Paraíba 2027, pontuam na temporada e indicam atletas ao
              Brasileiro. <strong className="font-semibold text-foreground">{deadline}</strong>
            </p>
          </div>
          <Link
            to="/chamamento-2027"
            className="btn-fpf3-primary inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-sm"
          >
            {cta}
          </Link>
        </div>
      </div>
    </section>
  );
}
